import React from 'react';
import './App.css';
import NewHome from './NewHome/NewHome';
import Footer from './components/Footer/Footer';
import ErrorReporter from './components/ErrorReporter/ErrorReporter';

function App() {
    return (
        <ErrorReporter>
            <NewHome/>
            <Footer/>
        </ErrorReporter>
    );
}

export default App;
